// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import VueResource from "vue-resource";
import VueSession from "vue-session";
import pako from "pako";
import draggable from "vuedraggable";
import Chart from "chart.js";
import store from './store';

const producao =
  window.location.href.indexOf("app.motorfiscal") != -1 ? true : false;
const canAccessRelatorio = ["fernando.ribeiro@compila.com.br","giovanne.ribeiro@compila.com.br","geovanna.brito@compila.com.br","nycollas.meneses@compila.com.br","wesley.peres@compila.com.br","giovanna.santos@compila.com.br"]
const uriAPI = producao
? "https://api.motorfiscal.com.br/"
: "https://apiteste.motorfiscal.com.br/";

Chart.defaults.global.defaultFontColor = "white";

Vue.use(Vuetify);
Vue.use(pako);
Vue.use(VueResource);
let options = { persist: false };
Vue.use(VueSession, options);
Vue.use(draggable);
Vue.prototype.$canAccessRelatorio = canAccessRelatorio;

// Vue.http.headers.common['Authorization'] = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3aWxsaWFtLnJvY2hhQGNvbXBpbGEuY29tLmJyIiwiaXNzIjoibW90b3ItYXBpIiwiaWF0IjoxNTQ5NDYxNDU0fQ.zOL9Ku5ympvkRFTNzrwx3LxgMmx_dXicu8cPHQQorJw';
// Vue.http.options.root = 'https://api.motorfiscal.com.br/';
// Vue.http.options.root = 'http://192.168.99.100/';

Vue.http.options.root = uriAPI;

Vue.config.productionTip = false;
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js